var _rect, _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrashGamesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_26584)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1003_26584",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 181,
    height: 180
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    width: 180,
    height: 180,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1003_26584)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.1665,
    cy: 140,
    rx: 72.5,
    ry: 30,
    fill: "#FEF6FA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.283 76.5664C131.625 79.8219 129.464 82.8145 126.862 85.4173C125.841 86.4375 124.747 87.4036 123.609 88.2881L61.5665 133.868L46.7979 119.1L92.3779 57.0569C93.2625 55.9192 94.2284 54.8249 95.2488 53.8045C97.8516 51.2017 100.844 49.0409 104.1 47.3835L133.283 76.5664Z",
    fill: "url(#paint0_linear_1003_26584)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.282 76.5663L104.1 47.3835C106.366 46.23 108.758 45.3182 111.239 44.6802L124.031 41.3904C128.3 40.2931 132.887 41.5471 136.003 44.6631C139.119 47.7792 140.373 52.3662 139.275 56.6342L135.986 69.427C135.348 71.9085 134.436 74.3005 133.282 76.5663ZM128.552 126.93L121.662 89.7189L98.5335 106.71L116.695 135.249C117.791 136.973 120.202 137.237 121.647 135.793L127.67 129.769C128.414 129.026 128.744 127.964 128.552 126.93ZM53.7364 52.1132C52.7024 51.9219 51.6405 52.2516 50.8969 52.9953L44.8734 59.0188C43.4287 60.4635 43.6933 62.8742 45.4169 63.971L73.9559 82.1323L90.9474 59.0041L53.7364 52.1132ZM39.255 94.0572C38.1399 93.7385 36.9398 94.0495 36.1195 94.8696L31.6014 99.3877C30.3542 100.635 30.3542 102.657 31.6014 103.904L46.7975 119.1L60.695 100.183L39.255 94.0572ZM61.5663 133.868L76.7623 149.064C78.0094 150.312 80.0314 150.312 81.2783 149.064L85.7965 144.546C86.6165 143.726 86.9276 142.526 86.6089 141.411L80.4832 119.971L61.5663 133.868Z",
    fill: "url(#paint1_linear_1003_26584)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1003_26584",
    x1: 54.1822,
    y1: 126.484,
    x2: 118.691,
    y2: 61.9751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1003_26584",
    x1: 85.166,
    y1: 40.9999,
    x2: 85.166,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79F2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_26584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrashGamesIcon);
export default __webpack_public_path__ + "static/media/crash-games-icon.91fbef7c2630758802a314f60308a43e.svg";
export { ForwardRef as ReactComponent };